import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  fieldData: {
    marginBottom: theme.sizes.spacing.default,
    '& > label': {
      marginBottom: '8px',
      display: 'block',
      color: '#666666',
      fontWeight: 'bold',
    },
    '& > div': {
      padding: '14px 18px',
      background: '#dddddd',
      border: '2px solid #999999',
      minHeight: '52px',
    }
  },
  fieldDataInner: {
    '& > label': {
      color: '#658d1b',
      fontSize: '12px',
    },
    '& > div': {
      marginBottom: '8px',
      fontSize: '16px',
    }
  }
}));

export default useStyles;
